import { render } from "./Family_C.vue?vue&type=template&id=6618bc89&scoped=true"
import script from "./Family_C.vue?vue&type=script&lang=js"
export * from "./Family_C.vue?vue&type=script&lang=js"

import "./Family_C.vue?vue&type=style&index=0&id=6618bc89&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6618bc89"]])

export default __exports__